// ── KC: Kræv aktivt størrelsesvalg før køb ──
// Ingen størrelse er valgt, når produktsiden eller hurtigkøb åbner.
// Køb-knappen viser "Vælg størrelse", indtil kunden selv vælger.
// Undtagelser: produkter med kun én størrelse, kun én størrelse på lager,
// og links der allerede peger på en bestemt variant (?variant=...),
// fx fra Google Shopping eller annoncer.
(function () {
  'use strict';

  var SIZE_OPTION_NAMES = ['størrelse', 'size', 'größe', 'grösse', 'taille'];

  var TEXTS = {
    da: { button: 'Vælg størrelse', error: 'Vælg venligst en størrelse' },
    de: { button: 'Größe wählen', error: 'Bitte wähle eine Größe' },
    en: { button: 'Select size', error: 'Please select a size' }
  };

  function texts() {
    var lang = (document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
    return TEXTS[lang] || TEXTS.en;
  }

  // Formularer hvor kunden allerede har valgt (nøgle: formularens id).
  var chosenForms = {};
  // Formularer der venter på størrelsesvalg (nøgle: formularens id).
  var pendingForms = {};

  function urlHasVariant() {
    return new URLSearchParams(window.location.search).has('variant');
  }

  function findSizeFieldset(picker) {
    var fieldsets = picker.querySelectorAll('fieldset.variant-picker__option');

    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      if (!legend) continue;

      var name = legend.textContent.replace(':', '').trim().toLowerCase();
      if (SIZE_OPTION_NAMES.indexOf(name) === -1) continue;

      var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
      var selectable = Array.prototype.filter.call(radios, function (radio) {
        var label = document.querySelector('label[for="' + radio.id + '"]');
        return !radio.disabled && !(label && label.classList.contains('is-disabled'));
      });

      // Kun én størrelse at vælge imellem: ingen grund til at tvinge et valg.
      if (selectable.length < 2) return null;

      return fieldsets[i];
    }

    return null;
  }

  function submitButtons(formId) {
    var form = document.getElementById(formId);
    var buttons = [];

    if (form) {
      form.querySelectorAll('button[type="submit"]').forEach(function (button) {
        buttons.push(button);
      });
    }

    document.querySelectorAll('button[type="submit"][form="' + formId + '"]').forEach(function (button) {
      if (buttons.indexOf(button) === -1) buttons.push(button);
    });

    return buttons;
  }

  function setPendingState(formId, isPending) {
    var form = document.getElementById(formId);
    if (form) form.classList.toggle('kc-size-pending', isPending);

    submitButtons(formId).forEach(function (button) {
      if (isPending) {
        if (button.dataset.kcOriginalText === undefined) {
          button.dataset.kcOriginalText = button.textContent;
        }
        button.textContent = texts().button;
      } else if (button.dataset.kcOriginalText !== undefined) {
        button.textContent = button.dataset.kcOriginalText;
        delete button.dataset.kcOriginalText;
      }
    });
  }

  function showError(fieldset) {
    var message = fieldset.querySelector('.kc-size-error');

    if (!message) {
      message = document.createElement('p');
      message.className = 'kc-size-error';
      message.setAttribute('role', 'alert');
      fieldset.appendChild(message);
    }

    message.textContent = texts().error;
    fieldset.classList.add('kc-size-missing');
    fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError(fieldset) {
    fieldset.classList.remove('kc-size-missing');
    var message = fieldset.querySelector('.kc-size-error');
    if (message) message.remove();
  }

  function preparePicker(picker) {
    if (picker._kcSizePrepared) return;
    picker._kcSizePrepared = true;

    var formId = picker.getAttribute('form-id');
    if (!formId || chosenForms[formId]) return;

    var context = picker.getAttribute('context');
    // På produktsiden respekteres et link til en bestemt variant.
    if (context === 'main_product' && urlHasVariant()) return;

    var fieldset = findSizeFieldset(picker);
    if (!fieldset) return;

    fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      radio.checked = false;
    });

    pendingForms[formId] = fieldset;
    setPendingState(formId, true);

    fieldset.addEventListener('change', function (event) {
      if (event.target.type !== 'radio') return;
      chosenForms[formId] = true;
      delete pendingForms[formId];
      clearError(fieldset);
      setPendingState(formId, false);
    });
  }

  function prepareAll(root) {
    (root || document).querySelectorAll('variant-picker').forEach(preparePicker);
  }

  // Stop køb, mens størrelsen mangler. Kører i capture-fasen,
  // så temaets egen kurv-logik aldrig modtager formularen.
  document.addEventListener('submit', function (event) {
    var formId = event.target && event.target.getAttribute('id');
    if (!formId || !pendingForms[formId]) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showError(pendingForms[formId]);
  }, true);

  // Samme stop for knapper der ligger uden for formularen (fx en klæbende købsbjælke).
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('button[type="submit"]');
    if (!button) return;

    var formId = button.getAttribute('form') || (button.form && button.form.getAttribute('id'));
    if (!formId || !pendingForms[formId]) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showError(pendingForms[formId]);
  }, true);

  function init() {
    prepareAll(document);

    // Hurtigkøb og andre dynamisk indlæste produktformularer.
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('variant-picker')) preparePicker(node);
          if (node.querySelectorAll) prepareAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
